export var GET_USER_REQUEST = 'app/UserEdit/GET_USER_REQUEST';
export var GET_USER_SUCCESS = 'app/UserEdit/GET_USER_SUCCESS';
export var GET_USER_FAILURE = 'app/UserEdit/GET_USER_FAILURE';
export var USER_NAME_UPDATE_REQUEST = 'app/UserEdit/USER_NAME_UPDATE_REQUEST';
export var USER_NAME_UPDATE_SUCCESS = 'app/UserEdit/USER_NAME_UPDATE_SUCCESS';
export var USER_NAME_UPDATE_FAILURE = 'app/UserEdit/USER_NAME_UPDATE_FAILURE';
export var GET_USER_PERMISSIONS_REQUEST = 'src/ViewOrganization/GET_USER_PERMISSIONS_REQUEST';
export var GET_USER_PERMISSIONS_SUCCESS = 'src/ViewOrganization/GET_USER_PERMISSIONS_SUCCESS';
export var GET_USER_PERMISSIONS_FAILURE = 'src/ViewOrganization/GET_USER_PERMISSIONS_FAILURE';
export var ItemLevelMap = {
    item: 'Items',
    org: 'Organization',
    app: 'App',
    appadmin: 'App Admin',
    partner: 'Partner',
    ds: 'Dataset Row',
};
